import CodeMirrorInput from "./CodeMirrorInput";
import UploadFormChild from "./UploadExcel"
import { Dropdown, FormInstance, Input, MenuProps } from "antd"
import { useState } from "react";
import { useTranslation } from "react-i18next";
import './FormAddrsChild.less'
import { cdnUrl } from "@/utils/cdn";
const simpleItems: MenuProps['items'] = [
  {
    key: '1',
    label: (
      <a target="_blank" href={cdnUrl("/demo/normal/xlsx-demo.xlsx")} download>
        Excel
      </a>
    ),
  },
  {
    key: '2',
    label: (
      <a target="_blank" href={cdnUrl("/demo/normal/csv-demo.csv")} download>
        CSV
      </a>
    )
  },
  {
    key: '3',
    label: (
      <a target="_blank" href={cdnUrl("/demo/normal/txt-demo.txt")} download>
        TXT
      </a>
    ),
  },
  {
    key: '4',
    label: (
      <a target="_blank" href={cdnUrl("/demo/normal/json-demo.json")} download>
        JSON
      </a>
    ),
  },
];

const moreItems: MenuProps['items'] = [
  {
    key: '1',
    label: (
      <a target="_blank" href={cdnUrl("/demo/proVersion/xlsx-demo.xlsx")} download>
        Excel
      </a>
    ),
  },
  {
    key: '2',
    label: (
      <a target="_blank" href={cdnUrl("/demo/proVersion/csv-demo.csv")} download>
        CSV
      </a>
    )
  },
  {
    key: '3',
    label: (
      <a target="_blank" href={cdnUrl("/demo/proVersion/txt-demo.txt")} download>
        TXT
      </a>
    ),
  },
  {
    key: '4',
    label: (
      <a target="_blank" href={cdnUrl("/demo/proVersion/json-demo.json")} download>
        JSON
      </a>
    ),
  },
];
const FormAddrsChild = ({ form, mode, onTabMode, ...restProps }: any) => {

  const { t } = useTranslation()
  const [opType, setOpType] = useState('simple')
  const [isUploadFileSuccess, setIsUploadFileSuccess] = useState(false)
  const placeholder = opType === 'simple' ? `5R16jjMXeQRsCSSo39F2r6QB7Da83wjEKt9AAbva76QQ` : `5R16jjMXeQRsCSSo39F2r6QB7Da83wjEKt9AAbva76QQ`
  function onDone(value: any = '') {
    form.setFieldValue('transferAddresses', value.trim())
    onTabMode(1)
  }

  function onInputCode(value: any) {
    const trimmedValue = value.replace(/ /g, ''); // 去掉所有空格
    // console.log(trimmedValue, 'value 123123');
    // setFormAddresses(value)
    form.setFieldValue('transferAddresses', trimmedValue)
  }

  function onError(bol: any = false) {
    setIsUploadFileSuccess(bol)
  }

  return (
    <div className="form-addrs-child">
      <Input {...restProps} type={'hidden'} />
      {
        mode === 2 ? <UploadFormChild onDone={onDone} /> : <CodeMirrorInput placeholder={placeholder} code={form.getFieldValue('transferAddresses')} opType={opType} onInputCode={onInputCode} onError={onError} />
      }
      {/* <div className='demo-box'>
        <p>{ t("components.maxSolanaDecimal") }</p>
      <Dropdown menu={{ items: opType === 'simple' ? simpleItems : moreItems }} trigger={['click']}>
        <a onClick={(e) => e.preventDefault()}>
          {
            t("components.TemplateFile")
          }
        </a>
      </Dropdown>
      </div> */}
    </div>
  )
}

export default FormAddrsChild